import { useTranslations } from 'next-intl'

import { TRoomDetail, usePropertyTypeMap } from '@/entities/room'

import { Heading, Item, Label, List, Value } from '../../common'

export type Props = Pick<
  TRoomDetail,
  'propertyType' | 'pyeongSize' | 'squareMeterSize'
>

export const Property = ({
  propertyType,
  pyeongSize,
  squareMeterSize,
}: Props) => {
  const t = useTranslations('room_detail')
  const { PROPERTY_TYPE_MAP } = usePropertyTypeMap()

  return (
    <div className="w-[260px] space-y-5">
      <Heading>{t('building_type_area.title')}</Heading>
      <List spacing="medium" className="typo-body2 text-gray-900">
        <Item className="justify-between">
          <Label icon="propertyType" className="font-semibold">
            {t('building_type_area.building_type')}
          </Label>
          <Value>{PROPERTY_TYPE_MAP[propertyType]}</Value>
        </Item>
        <Item className="justify-between gap-2">
          <Label icon="pyeongSize" className="font-semibold">
            {t('building_type_area.area')}
          </Label>
          <Value className="text-end">
            {t('area.pyeong', {
              pyeongSize,
              squareMeterSize: Math.round(squareMeterSize),
            })}
          </Value>
        </Item>
      </List>
    </div>
  )
}
